import type { CmsRestaurantAdmin, CmsRestaurantRow, RestaurantAccountManager } from 'apis/restaurants/types';

export interface RestaurantListRow {
  id: number;
  name: {
    name: string;
    imageUrl: string | null;
    id: number;
  };
  admin: CmsRestaurantAdmin | null;
  accountManager: RestaurantAccountManager | null;
  vatValue: number | null;
  createdAt: string;
  actions: CmsRestaurantRow;
}

// Maps one UMS `api/v1/restaurants` row to the shape the list screen's columns read from.
// `actions` carries the whole row so RestaurantActionsCell has everything it needs (id,
// countryCode, accountManager, ...) without a second lookup.
export const toRestaurantRow = (restaurant: CmsRestaurantRow): RestaurantListRow => ({
  id: restaurant.id,
  name: {
    name: restaurant.nameEn,
    imageUrl: restaurant.imageUrl,
    id: restaurant.id,
  },
  admin: restaurant.admin,
  accountManager: restaurant.accountManager,
  vatValue: restaurant.vatValue,
  createdAt: restaurant.createdAt,
  actions: restaurant,
});
